<template>
  <div>
    <span
      v-if="
        (typeof ownerStatementID === 'string' || typeof ownerStatementID === 'number') &&
          documentID > 0
      "
    >
      <button
        class="button is-info is-light is-small is-outline is-rounded"
        @click.prevent="downloadPdf(ownerStatementID, documentURL)"
      >
        Pdf
      </button>
    </span>
    <span v-else>
      &nbsp;
    </span>
  </div>
</template>

<script>
export default {
  props: {
    ownerStatementID: [Number, String],
    documentID: [Number, String],
    documentURL: String,
    downloadPdf: Function
  }
}
</script>
